/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Story_Manage_ExpiresInputs */

const en_story_manage_expires = /** @type {(inputs: Story_Manage_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires: ${i?.time}`)
};

const es_story_manage_expires = /** @type {(inputs: Story_Manage_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expira: ${i?.time}`)
};

const fr_story_manage_expires = /** @type {(inputs: Story_Manage_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expire : ${i?.time}`)
};

const de_story_manage_expires = /** @type {(inputs: Story_Manage_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Läuft ab: ${i?.time}`)
};

const id_story_manage_expires = /** @type {(inputs: Story_Manage_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kedaluwarsa: ${i?.time}`)
};

/** @type {(inputs: Story_Manage_ExpiresInputs) => LocalizedString} */
const ja_story_manage_expires = en_story_manage_expires;

/** @type {(inputs: Story_Manage_ExpiresInputs) => LocalizedString} */
const zh_story_manage_expires = en_story_manage_expires;

/** @type {(inputs: Story_Manage_ExpiresInputs) => LocalizedString} */
const ar_story_manage_expires = en_story_manage_expires;

/** @type {(inputs: Story_Manage_ExpiresInputs) => LocalizedString} */
const it_story_manage_expires = en_story_manage_expires;

/** @type {(inputs: Story_Manage_ExpiresInputs) => LocalizedString} */
const ru_story_manage_expires = en_story_manage_expires;

/** @type {(inputs: Story_Manage_ExpiresInputs) => LocalizedString} */
const pt_story_manage_expires = en_story_manage_expires;

/** @type {(inputs: Story_Manage_ExpiresInputs) => LocalizedString} */
const ko_story_manage_expires = en_story_manage_expires;

/**
* | output |
* | --- |
* | "Expires: {time}" |
*
* @param {Story_Manage_ExpiresInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_manage_expires = /** @type {((inputs: Story_Manage_ExpiresInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Manage_ExpiresInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_manage_expires(inputs)
	if (locale === "es") return es_story_manage_expires(inputs)
	if (locale === "fr") return fr_story_manage_expires(inputs)
	if (locale === "de") return de_story_manage_expires(inputs)
	if (locale === "ja") return ja_story_manage_expires(inputs)
	if (locale === "zh") return zh_story_manage_expires(inputs)
	if (locale === "ar") return ar_story_manage_expires(inputs)
	if (locale === "id") return id_story_manage_expires(inputs)
	if (locale === "it") return it_story_manage_expires(inputs)
	if (locale === "ru") return ru_story_manage_expires(inputs)
	if (locale === "pt") return pt_story_manage_expires(inputs)
	return ko_story_manage_expires(inputs)
});